/* eslint-disable max-len */
import React, { useEffect, useState, useCallback, useRef, useLayoutEffect } from "react"
import { dataService } from "../../../services/dataService"
import { useNavigate, useParams } from "react-router-dom";
import config from "../../../config";
import { Auth } from "aws-amplify";
import { io } from "socket.io-client";
import { Triangle } from "react-loader-spinner";
import PlaceBidCard from "../carousel-view/PlaceBidCard";
import VerticalMarquee from "./VerticleMarquee";

export default function LeaderBoardView(){
    const { uid } = useParams();
    const [socket,setSocket] = useState(null);
    const [lots, setLots] = useState([])
    const [currentLotIndex, setCurrentLotIndex] = useState(0);
    const [placeBidQueue, setPlaceBidQueue] = useState([]);
    const [currentPlaceBid, setCurrentPlaceBid] = useState(null);
    const [showPlaceBid, setShowPlaceBid] = useState(false);
    const [pausedLotIndex, setPausedLotIndex] = useState(null);
    const [auctionData, setAutcionData] = useState({});
    const [loading, setLoading] = useState(true);
    const Navigate = useNavigate();
    const wakeLockRef = useRef(null);

    useEffect(() => {
        let isSupported = "wakeLock" in navigator;

        const requestWakeLock = async () => {
            try {
                if (isSupported) {
                    wakeLockRef.current = await navigator.wakeLock.request("screen");
                    console.log("Wake lock is active");
                    wakeLockRef.current.addEventListener("release", () => {
                        console.log("Wake lock was released");
                    });
                }
            } catch (err) {
                console.error(`${err.name}, ${err.message}`);
            }
        };

        // Initial request
        requestWakeLock();

        // Re-request on visibility change
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                requestWakeLock();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            if (wakeLockRef.current) {
                wakeLockRef.current.release();
                wakeLockRef.current = null;
            }
        };
    }, []);

    const getLeaderboardData = async ()=>{
        const response = await dataService.GetLeaderboard(uid)
        if(response.error == false){
            setAutcionData(response.data.data);
            if(response.data.data.status!=="Accepting bids" && response.data.data.status!=="Published"){
                Navigate('/page-not-found');
            }
        }
    }

    const socketConnection = async(lots)=>{
        const idToken = await Auth.currentSession()
    
        if(socket == null){
            const socketConn = io(config.SOCKETURL, {
                transports: ['websocket'],
                auth: {
                    token: idToken.getIdToken().getJwtToken(),
                    type: "seller"
                },
                reconnection: true
            })
    
            setSocket(socketConn);
    
            lots.map((lot)=>{
                socketConn.on('authorization', (message)=>{
                    if(message.success_status == true){
                        socketConn.emit('joinBidRoom', lot?._id, "seller");
                    }
                })
            })
                
            socketConn?.on('placeBid',(message)=>{
                if(message.success==true && message.newCurrentLotDetails){
                    const lotDetails = message.newCurrentLotDetails;
                    setLots(prevLots => 
                        prevLots.map(lot => 
                            lot._id === lotDetails._id 
                                ? {
                                    ...lot,
                                    ...(lotDetails.bid_amount && { current_bid: lotDetails.bid_amount }),
                                    ...(lotDetails.paddle_number && { paddle_number: lotDetails.paddle_number })
                                }
                                : lot
                        )
                    );
                    setPlaceBidQueue(prev => [...prev, lotDetails._id]);
                    setCurrentLotIndex(prevIndex => {
                        if (!showPlaceBid) {
                            setPausedLotIndex(prevIndex);
                        }
                        return prevIndex;
                    });
                }
            })
    
        }else{
            lots.map((lot)=>{
                socket.emit('joinBidRoom', lot?._id, "seller");
            })
        }
    }

    const fetchLots = async() =>{
        let endpoint = `?auction_id=${uid}&per_page=500`
        const response = await dataService.LotList(endpoint)
        if(response.error == false) {
            setLots(response.data.data)
            socketConnection(response.data.data)
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!showPlaceBid) {
            const interval = setInterval(() => {
                setCurrentLotIndex((prevIndex) => {
                    const nextIndex = prevIndex + 1;
                    return nextIndex >= lots.length ? 0 : nextIndex;
                });
            }, 5000);

            return () => clearInterval(interval);
        }
    }, [lots.length, showPlaceBid]);

    useEffect(() => {
        if (placeBidQueue.length > 0 && !showPlaceBid) {
            const nextBid = lots.find(lot => lot._id === placeBidQueue[0]) || currentLot
            setCurrentPlaceBid(nextBid);
            setShowPlaceBid(true);
      
            // Remove from queue
            setPlaceBidQueue(prev => prev.slice(1));
        }
    }, [placeBidQueue.length, showPlaceBid]);

    // Handle hiding the place bid overlay after 3 seconds
    useEffect(() => {
        if (showPlaceBid) {
            const timer = setTimeout(() => {
                setShowPlaceBid(false);
                setCurrentPlaceBid(null);
                setCurrentLotIndex(pausedLotIndex);
                setPausedLotIndex(null);
            }, 5000);
      
            return () => {
                clearTimeout(timer);
            };
        }
    }, [showPlaceBid]);

    const currentLot = lots[currentLotIndex];

    useEffect(()=>{
        getLeaderboardData()
        fetchLots()
    },[])

    return(
        <div className="min-h-screen flex items-center justify-center">
            {!loading && Object.keys(auctionData).length>0 && (
                <div
                    className="relative bg-cover bg-[#E6E6E6]"
                    style={{
                        aspectRatio: '16/9',
                        width: '100vw',
                        height: '56.25vw',
                        maxWidth: '177.78vh',
                        maxHeight: '100vh',
                        backgroundColor: auctionData?.event_display?.background_color,
                        backgroundImage: auctionData?.event_display?.background_image && auctionData?.event_display?.background_image.trim() !== ''
                            ? `url(${config.Storage.CDN}${auctionData?.event_display?.background_image})`
                            : undefined,
                        backgroundSize: 'cover'
                    }}
                >
                    <LeaderBoardPreview 
                        auctionData={auctionData} 
                        lotData={lots} 
                        showPlaceBid={showPlaceBid}
                        currentPlaceBid={currentPlaceBid}
                    />
                </div>
            )}
            {loading && (
                <div className="fixed inset-0 bg-[#E6E6E6] flex justify-center items-center z-[9999]">
                    <Triangle
                        height="80"
                        width="80"
                        color="#000"
                        ariaLabel="triangle-loading"
                        visible={true}
                    />
                </div>
            )}
        </div>
    )
}

function LogoPreview({ auctionData}) {
    const leftLogo = auctionData?.event_display?.left_logo_image
    const rightLogo = auctionData?.event_display?.right_logo_image
    return (
        <>
            {leftLogo ?
                <img 
                    src={`${config.Storage.CDN}${leftLogo}`} 
                    className="h-full w-auto" 
                    alt="Left Logo" 
                /> 
                : <div className="w-[100px]" />
            }
            <div className="flex-grow" />
            {rightLogo ?
                <img 
                    src={`${config.Storage.CDN}${rightLogo}`} 
                    className="h-full w-auto" 
                    alt="Right Logo" 
                />
                : <div className="w-[100px]" />
            }
        </>
    )
}

export function LeaderBoardPreview({ auctionData, lotData = [], showPlaceBid, currentPlaceBid }) {
    
    const containerRef = useRef(null);
    
    return (
        <>
            <div className="absolute top-0 left-0 right-0 px-[4%] pb-[1%] pt-[3%] h-[17%] z-10 bg-transparent flex justify-between">
                <LogoPreview auctionData={auctionData} />
            </div>
            {showPlaceBid && currentPlaceBid && (<>
                <div className="h-[10%] " >
                </div>
                <div className="h-full max-h-[90%] flex items-center justify-center">
                    <PlaceBidCard currentLot={currentPlaceBid} currency={auctionData?.currency} />
                </div>
            </>)}
            <div 
                ref={containerRef} 
                className="absolute left-0 right-0 overflow-hidden px-[4%] 
                    pointer-events-none vertical-marquee-container"
                style={{ top: '17%', bottom: '12%' }}
            >
                {!showPlaceBid &&
                    <VerticalMarquee items={lotData} auctionData={auctionData} />
                }
            </div>
            <div className="text-white flex absolute justify-end items-end bottom-[7%] right-[6%]" style={{ fontSize: '0.73vw' }}>
                <span className="mb-1 mr-2" >Powered by</span>
                <span className="font-bold" style={{ fontSize: '1.35vw' }}>indy</span>
                <span style={{ fontSize: '1.35vw' }}>.auction</span>
            </div>
        </>
    )
}